import React from "react";
import "./LoginModal.css";

function LoginModal() {
  return (
    <div
      className="modal fade"
      id="loginModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered login-modal">
        <div className="modal-content login-modal-content">
          <button
            type="button"
            className="btn-close custom-close"
            data-bs-dismiss="modal"
          ></button>

          <div className="row g-0 h-100">
            {/* Left Side */}
            <div className="col-md-5">
              <div className="login-left">
                <div className="login-left-content">
                  <h5>Welcome To</h5>
                  <h1>Everything Pawzible</h1>
                  <p>Care • Connect • Compassion</p>
                </div>

                <img
                  className="pet-img"
                  src={`${process.env.PUBLIC_URL}/assets/imgs/banner_1.png`}
                  alt="Banner_1"
                />
              </div>
            </div>

            {/* Right Side */}
            <div className="col-md-7">
              <div className="login-right">
                <div className="login-heading">
                  <h2>Login</h2>
                  <p>
                    New User? <a href="" data-bs-toggle="modal" data-bs-target="#RegistrationModal">Sign Up</a>
                  </p>
                </div>

                <form>
                  <div className="user-type-wrapper">
                    <label className="user-type-card">
                      <input
                        type="radio"
                        name="userType"
                        value="petOwner"
                        defaultChecked
                      />
                      <span>🐾 Pet Owner</span>
                    </label>

                    <label className="user-type-card">
                      <input type="radio" name="userType" value="provider" />
                      <span>🏥 Service Provider</span>
                    </label>
                  </div>
                  <div className="input_container">
                    <label>Email / Phone Number</label>
                    <input
                      type="text"
                      className="form-control custom-input"
                      placeholder="Enter Email or Phone Number"
                    />
                  </div>

                  <div className="input_container">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control custom-input"
                      placeholder="Enter Password"
                    />
                  </div>

                  <div className="text-end input_container">
                    <a href="/" className="forgot-link">
                      Forgot Password?
                    </a>
                  </div>

                  <button type="button" className="btn login-btn w-100">
                    Login
                  </button>

                  <div className="or-divider">
                    <span>OR</span>
                  </div>

                  <button type="button" className="btn google-btn w-100">
                    Continue with Google
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;
